<template>
  <div>
    <el-dialog
      title="支付方式"
      :visible.sync="payVisible"
      width="30%"
      :showClose="true"
      center
      customClass="pay-dialog"
      :close-on-click-modal="false"
      @closed="handleClosed"
      @opened="handleOpened"
    >
      <p class="left-time">支付剩余时间 {{ countdown | countdownFormat }}</p>
      <p class="price">
        <span class="mark">¥</span>
        <span>{{ payPrice / 100 }}</span>
      </p>
      <div class="pay-code">
        <!--        <div class="qr-box ali-pay">-->
        <!--          <div class="generate-qr-box">-->
        <!--            <div class="qr-code" ref="aliQr"></div>-->
        <!--          </div>-->
        <!--          <div v-if="countdown <= 0" class="fail">-->
        <!--            <p class="fail-tip">支付超时</p>-->
        <!--          </div>-->
        <!--          <p class="tip">-->
        <!--            <img :src="require('@/assets/img/alipay.png')" alt="" />-->
        <!--            <span>支付宝</span>-->
        <!--          </p>-->
        <!--        </div>-->
        <div class="qr-box we-chat-pay">
          <div class="generate-qr-box">
            <div class="qr-code" ref="weChatQr"></div>
          </div>
          <div v-if="countdown <= 0" class="fail">
            <p class="fail-tip">支付超时</p>
          </div>
          <p class="tip">
            <img :src="require('@/assets/img/wepay.png')" alt="" />
            <span>微信支付</span>
          </p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onCompletePay">我已完成支付</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="支付成功"
      customClass="pay-success-dialog"
      :visible.sync="paymentCompletedVisible"
      width="20%"
      center
      :showClose="false"
      :closeOnClickModal="false"
    >
      <p class="price">¥{{ payPrice / 100 }}</p>
      <p class="tip">{{ tip || '支付成功，新合同预计5分钟内生效' }}</p>
      <p slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmPayCompleted">我知道了</el-button>
      </p>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from 'easyqrcodejs';

const logo = require('@/assets/img/wzlogo.png');
let countdownTimer = null;
let pollingTimer = null;
export default {
  name: 'payDialog',
  computed: {
    qrObj() {
      const { aliPayString, weChatPayString } = this;
      return {
        // aliQr: {
        //   payString: aliPayString,
        //   width: 185,
        //   height: 185,
        //   logoWidth: 55,
        //   logoHeight: 55
        // },
        weChatQr: {
          payString: weChatPayString,
          width: 180,
          height: 180,
          logoWidth: 50,
          logoHeight: 50
        }
      };
    }
  },
  data() {
    return {
      tradeNo: '',
      aliPayString: '',
      weChatPayString: '',
      countdown: 0,
      payPrice: 0,
      payVisible: false,
      aliQr: null,
      paymentCompletedVisible: false
    };
  },
  methods: {
    init() {
      clearInterval(countdownTimer);
      clearInterval(pollingTimer);
      this.clearPayQr();
    },
    handleClosed() {
      this.init();
    },
    handleOpened() {
      this.generatePayQr();
    },
    show() {
      this.payVisible = true;
      this.handlerCountdown();
      this.queryPayResultPolling();
    },
    close() {
      this.payVisible = false;
      this.paymentCompletedVisible = false;
      this.init();
    },
    generatePayQr() {
      const { qrObj } = this;
      Object.keys(qrObj).forEach(item => {
        const { payString, width, height, logoWidth, logoHeight } = qrObj[item];
        this[item] = new QRCode(this.$refs[item], {
          text: payString,
          width,
          height,
          logoWidth,
          logoHeight,
          logoBackgroundTransparent: true,
          colorDark: '#000000',
          logo: logo
        });
      });
    },
    clearPayQr() {
      Object.keys(this.qrObj).forEach(item => {
        if (this[item]) this[item].clear();
      });
    },
    async onCompletePay() {
      const {
        data: { tradeStatus = 0 }
      } = await this.queryPayResult(true);
      if (tradeStatus === 1) {
        this.payVisible = false;
        this.openPaymentCompletedDialog();
        return;
      }
      this.$message('支付进行中，请稍后再试');
    },
    openPaymentCompletedDialog() {
      this.paymentCompletedVisible = true;
    },
    handlerCountdown() {
      if (countdownTimer) clearInterval(countdownTimer);
      countdownTimer = setInterval(() => {
        this.countdown = this.countdown - 1;
        if (this.countdown <= 0) {
          clearInterval(countdownTimer);
          clearTimeout(pollingTimer);
        }
      }, 1000);
    },
    queryPayResultPolling() {
      // 偶现关闭弹窗后，还在发起请求，再加一层判断，
      if (!this.payVisible) {
        clearInterval(countdownTimer);
        clearInterval(pollingTimer);
        return;
      }
      pollingTimer = setTimeout(async () => {
        let {
          data: { tradeStatus = 0 }
        } = await this.queryPayResult();
        if (tradeStatus === 1) {
          this.payVisible = false;
          setTimeout(() => {
            this.paymentCompletedVisible = true;
          }, 1000);
          this.onPaySuccess();
          return;
        }
        if (tradeStatus === 0) {
          this.queryPayResultPolling();
        }
      }, 2000);
    },
    async queryPayResult() {
      const { tradeNo } = this;
      const res = await Fetch.queryPayResult({ tradeNo, queryThirdPlatform: true });
      return res;
    },
    // 确认支付完成
    confirmPayCompleted() {
      this.onConfirmPayCompleted();
    }
  },
  filters: {
    countdownFormat(time) {
      let minute = parseInt(time / 60);
      let second = parseInt(time % 60);
      return `00:${minute > 9 ? minute : `0${minute}`}:${second > 9 ? second : `0${second}`}`;
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog {
  &.pay-dialog {
    min-width: 500px;
  }
  &.pay-success-dialog {
    min-width: 340px;
  }
  text-align: center;
  .el-dialog__headerbtn {
    display: block;
  }
  .el-dialog__body {
    text-align: center;
  }
}
.pay-dialog {
  .left-time {
    margin: 16px 0 12px 0;
    font-size: 14px;
    line-height: 14px;
    color: #8c8c8c;
  }
  .price {
    padding-bottom: 38px;
    font-size: 36px;
    font-weight: 600;
    color: #262626;
    line-height: 36px;
    .mark {
      margin-right: 4px;
      font-size: 18px;
    }
  }
  .pay-code {
    display: flex;
    justify-content: center;
    gap: 40px;
    .qr-box {
      position: relative;
      .generate-qr-box {
        height: 180px;
        width: 180px;
        /deep/.qr-code canvas {
          height: 180px;
          width: 180px;
        }
      }
      img {
        height: 180px;
        width: 180px;
      }
      &.ali-pay {
        color: #3296fa;
      }
      &.we-chat-pay {
        color: #1e8dff;
      }
      .tip {
        display: flex;
        padding-top: 12px;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        img {
          width: 24px;
          height: 24px;
          margin-right: 8px;
        }
      }
      .fail {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        height: 180px;
        background: rgba(255, 255, 255, 0.95);
        .fail-tip {
          position: relative;
          top: 50%;
          transform: translateY(-50%);
          width: 100%;
          background: rgba(89, 89, 89, 0.9);
          height: 48px;
          line-height: 48px;
          font-size: 14px;
          font-weight: 400;
          color: #ffffff;
        }
      }
    }
  }
}
.pay-success-dialog {
  .price {
    margin-top: 38px;
    font-size: 36px;
    font-weight: 500;
    color: #1e8dff;
    line-height: 36px;
  }
  .tip {
    margin: 10px 0 60px 0;
    font-size: 14px;
    font-weight: 400;
    color: #595959;
  }
}
</style>
